import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'

import Button from '@/components/Button'
import Icon from '@/components/Icon'
import Toggle from '@/components/Toggle'

import axios from 'axios'

//import XLSX from 'xlsx'


import settings from './settings'
import Circle from './components/circle/Circle.vue'



//import VueAxios from 'vue-axios'

if (process.env.NODE_ENV == "development") {
	axios.defaults.baseURL = "http://api-w3.boove.se.dev2/w3/v1/";
	axios.defaults.timeout = 30 * 1000;
	store.state.debug = false;
	store.state.loginStatusInterval = 10
	settings.baseUrl = "http://api-w3.boove.se.dev2/w3/v1/"
	//settings.baseUrl = "http://api-w3.boove.se.dev2/w3/v1/" // FP: Ändrade från 192.168.1.9 
	/*settings.baseUrl = "http://192.168.1.9/w3/v1/" // FP: Testa på mobilen */

	settings.baseImagePath = "http://public.boove.se/w2image/";
	
	//settings.baseImagePath = "http://public2.boove.se.dev2/w3image/";

} else {

	store.state.debug = false;
	axios.defaults.timeout = 60 * 1000;
	store.state.loginStatusInterval = 120

	// FP: PROD S3 
	axios.defaults.baseURL = "https://api-w3.boove.se/w3/v1/";
	settings.baseUrl = "https://api-w3.boove.se/w3/v1/";
	settings.baseImagePath = "https://public.boove.se/w2image/";
	settings.clientBaseUrl = "https://w3.boove.se";
	settings.state = "prod";
	settings.server = "prod"; // */


	// FP: TEST S4 
	/*axios.defaults.baseURL = "https://test.api-w3.s4.boove.se/w3/v1/";
	settings.baseUrl = "https://test.api-w3.s4.boove.se/w3/v1/";
	settings.baseImagePath = "https://test.public.s4.boove.se/w2image/";
	settings.clientBaseUrl = "https://test.w3.s4.boove.se";
	settings.state = "test";
	settings.server = "s4"; // */

	// FP: PROD S4 
	/*axios.defaults.baseURL = "https://prod.api-w3.s4.boove.se/w3/v1/";
	settings.baseUrl = "https://prod.api-w3.s4.boove.se/w3/v1/";
	settings.baseImagePath = "https://prod.public.s4.boove.se/w2image/";
	settings.clientBaseUrl = "https://prod.w3.s4.boove.se";
	settings.state = "prod";
	settings.server = "s4"; // */

	// FP: TEST S5 
	/*axios.defaults.baseURL = "https://test.api-w3.s5.boove.se/w3/v1/";
	settings.baseUrl = "https://test.api-w3.s5.boove.se/w3/v1/";
	settings.baseImagePath = "https://test.public.s5.boove.se/w2image/";
	settings.clientBaseUrl = "https://test.w3.s5.boove.se";
	settings.state = "test";
	settings.server = "s5"; // */

	// FP: PROD S5 
	/*axios.defaults.baseURL = "https://prod.api-w3.s5.boove.se/w3/v1/";
	settings.baseUrl = "https://prod.api-w3.s5.boove.se/w3/v1/";
	settings.baseImagePath = "https://prod.public.s5.boove.se/w2image/";
	settings.clientBaseUrl = "https://prod.w3.s5.boove.se";
	settings.state = "prod";
	settings.server = "s5"; // */


}

settings.manufactorLogoPath = "https://public.boove.se/gfx/logos/"

//createApp(App).use(store).use(router, axios, VueAxios).mount('#app')

const app = createApp(App)

app.use(store)

app.use(router, axios)

//app.config.globalProperties.$konstanter = konstanter

app.component('Button', Button)
app.component('Icon', Icon)
app.component('Toggle', Toggle)

app.component('Circle', Circle)


app.mixin({
	computed: {
		debug() {
			return this.$store.state.debug
		},

		isLoggedIn() {
			return this.$store.state.loginToken != null
		},

		environmentDev(){
			return process.env.NODE_ENV == "development"
		}
	},


})

app.mount('#app')